export enum CategoryFormMode {
    EDIT = 'EDIT',
    CREATE = 'CREATE',
}
